/**
 * OrbDocCoreConceptsEntitiesSLDocEx1NoteListView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsEntitiesSLDocEx1NoteList
 */

import { useOrbDocCoreConceptsEntitiesSLDocEx1NoteListLogic } from '@/hooks/traits/useOrbDocCoreConceptsEntitiesSLDocEx1NoteListLogic';
import type { OrbDocCoreConceptsEntitiesSLDocEx1NoteListConfig } from '@/hooks/traits/useOrbDocCoreConceptsEntitiesSLDocEx1NoteListLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsEntitiesSLNote } from '@app/shared';
import { Alert } from '@almadar/ui/components';
import { DataList } from '@almadar/ui/components';
import { Skeleton } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsEntitiesSLDocEx1NoteListViewProps {
  config?: Partial<OrbDocCoreConceptsEntitiesSLDocEx1NoteListConfig>;
}

export function OrbDocCoreConceptsEntitiesSLDocEx1NoteListView({ config: propsConfig }: OrbDocCoreConceptsEntitiesSLDocEx1NoteListViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsEntitiesSLDocEx1NoteListLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsEntitiesSLNote'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsEntitiesSL" trait="OrbDocCoreConceptsEntitiesSLDocEx1NoteList">
      {slotWriter['main'] === 'INIT' ? (<Skeleton variant="list" rows={2} />) : slotWriter['main'] === 'NotesLoaded' ? (<DataList entity={Array.isArray(lastPayload?.data) ? ((lastPayload?.data) as readonly EntityRow[]) : []} fields={Array.isArray([{ name: "title", label: "Title", variant: "h4" }, { name: "body", label: "Note", variant: "body" }]) ? ((([{ name: "title", label: "Title", variant: "h4" }, { name: "body", label: "Note", variant: "body" }]) as EntityRow[]) as ({ colorMap?: never; format?: 'date' | 'time' | 'datetime' | 'currency' | 'number' | 'boolean' | 'percent'; icon?: string; label?: string; labels?: never; name: string; variant?: 'h3' | 'h4' | 'overline' | 'avatar' | 'body' | 'caption' | 'badge' | 'small' | 'progress' })[]) : []} emptyTitle="No notes yet" emptyDescription="Add one with the form." emptyIcon="file-text" />) : slotWriter['main'] === 'NotesFailed' ? (<Alert variant="error" message={(lastPayload?.error == null ? undefined : String(lastPayload?.error))} />) : null}
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsEntitiesSLDocEx1NoteListView;
